import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import type { StaticImageData } from 'Components/Image';
import { Typography } from 'Components/Typography';

import { moduleBigHands } from 'assets/content/landingPages/supplements';

const Root = styled.section<{
  img: { mobile: StaticImageData; tablet: StaticImageData; desktop: StaticImageData };
}>`
  width: 100vw;
  height: 100%;
  padding: 56px 24px 70vw;

  background-image: ${({ img }) => `url(${img.mobile.src})`};
  background-size: cover;
  background-position: bottom center;
  border-bottom: 2px solid ${theme.colors.primary[400]};

  ${legacyTheme.breakpoints.up('xs')} {
    padding-bottom: 60vw;
  }

  ${legacyTheme.breakpoints.up('sm')} {
    padding: 104px 72px 50vw;
    background-image: ${({ img }) => `url(${img.tablet.src})`};
  }

  ${legacyTheme.breakpoints.up('md')} {
    padding: 138px 135px 90vw;
    background-image: ${({ img }) => `url(${img.desktop.src})`};
  }

  ${legacyTheme.breakpoints.up('lg')} {
    padding-bottom: 50vw;
  }

  ${legacyTheme.breakpoints.up('xl')} {
    padding-bottom: 40vw;
  }
`;

const Paragraph = styled(Typography)`
  font-size: 44px;
  font-weight: 300;
  line-height: 1.13;
  letter-spacing: 0.25px;

  ${legacyTheme.breakpoints.up('xs')} {
    font-size: 48px;
  }

  ${legacyTheme.breakpoints.up('sm')} {
    font-size: 60px;
    font-weight: 300;
    line-height: 1.2;
    letter-spacing: 0.31px;
  }

  ${legacyTheme.breakpoints.up('md')} {
    font-size: 100px;
    font-weight: 300;
    line-height: 1.12;
    letter-spacing: normal;
  }
`;

export const ModuleBigHands = () => (
  <Root data-testid="supplements-landing-module" img={moduleBigHands.image}>
    {moduleBigHands.paragraphs.map((el, key) => (
      <Paragraph key={String(key)} variant="p1">
        {el}
      </Paragraph>
    ))}
  </Root>
);
